import React, { Component } from 'react';
import Card from './Card';
import OpenStreetMap from './OpenStreetMap';


class MapCard extends Component {


  render() {

      return (
        <Card body={
            <OpenStreetMap
              markers={this.props.markers ?  this.props.markers : [] }
              polylines={this.props.polylines ? this.props.polylines : [] }
              polygons={this.props.polygons ? this.props.polygons : [] }
              markerTitle={this.props.markerTitle}
              markerPopupColumns={this.props.markerPopupColumns}
              mapPositionLat={this.props.mapPositionLat}
              mapPositionLng={this.props.mapPositionLng}
              mapZoomLevel={this.props.mapZoomLevel}
              latName={this.props.latName}
              lonName={this.props.lonName}
              geojson={this.props.geojson}
              ></OpenStreetMap>
          }>
        </Card>
	     )
  }
}

export default MapCard;
